import { get } from "lodash";
import { PROFILE_LIST } from "utils/constants";

const NON_RESPONSIBLE_GAMME_IDENTIFIERS = ["zenitude", "zen0p0"];

/** Legacy Acoris profile ids mapped to canonical {@link PROFILE_LIST} values. */
const LEGACY_ACORIS_PROFILE_TO_PROFILE_LIST = {
  PARTICULIER: PROFILE_LIST.PARTICULAR,
  INDEPENDANT_TNS: PROFILE_LIST.TNS,
  INDEPENDANT: PROFILE_LIST.TNS,
  AGENT_TERRITORIAL: PROFILE_LIST.TERRITORIAL_AGENT,
  ENTREPRISE: PROFILE_LIST.BUSINESS_LEADER,
  FRONTALIER_LUXEMBOURGEOIS: PROFILE_LIST.CROSS_BORDER_WORKER,
  FRONTALIER: PROFILE_LIST.CROSS_BORDER_WORKER,
};

/**
 * Normalizes stored profile values to canonical PROFILE_LIST values used in
 * Health administration and buildGeneralCosts eligibility rules.
 */
export const normalizeAcorisProfile = (profile) => {
  if (!profile) return profile;

  if (Object.values(PROFILE_LIST).includes(profile)) {
    return profile;
  }

  return LEGACY_ACORIS_PROFILE_TO_PROFILE_LIST[profile] || profile;
};

const normalizeGammeLabel = (value) =>
  String(value || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

export const isAcorisNonResponsiblePlan = (insurancePlan) => {
  if (get(insurancePlan, "fields.nonResponsible") === true) {
    return true;
  }

  const label = normalizeGammeLabel(
    [
      get(insurancePlan, "name"),
      get(insurancePlan, "alias"),
      get(insurancePlan, "product"),
      get(insurancePlan, "category"),
      get(insurancePlan, "externalId"),
      get(insurancePlan, "identifier"),
    ]
      .filter(Boolean)
      .join(" "),
  );
  return NON_RESPONSIBLE_GAMME_IDENTIFIERS.some((identifier) =>
    label.includes(identifier),
  );
};
